import axiosInstance from "api/axiosInstance";
import { convertOffsetToTimes } from "framer-motion";

export const getBotInfo = async (username) => {
  try {
    const response = await axiosInstance.get(`/business/@${username}`);
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = `/${username}`;
        return;
      }
      if (status === 404) {
        console.warn("خطای 404: بات مورد نظر یافت نشد.");
        window.location.href = "/notfound";
        return;
      }

      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const getBotStatus = async (username) => {
  try {
    const response = await axiosInstance.get(`/business/@${username}`);
    return response.data.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;

      if (status === 403) {
        window.location.href = `/${username}`;
        return;
      }

      if (status === 404) {
        console.warn("کاربر هنوز بات ندارد.");
        return {
          status: "inactive"
        };
      }

      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته"
      };

    } else {
      throw {
        statusCode: 500,
        message: "مشکل شبکه یا عدم دسترسی به سرور"
      };
    }
  }
};
